<div [formGroup]="form" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
  <mat-form-field>
    <mat-label>Points per bottle</mat-label>
    <input matInput required type="number" placeholder="" min="0" step="1" formControlName="pointsPerBottle">
  </mat-form-field>
  <mat-form-field class="multi-labels">
    <mat-label>Bottle product selection</mat-label>
    <mat-chip-grid #chipList aria-label="Bottle product selection">
      @for (prod of selectedProducts; track prod; let i = $index) {
        <mat-chip-row
          (removed)="remove(i)">
          {{ prod.name }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
      <input #bottleProdIdInput
        #trigger="matAutocompleteTrigger"
        [formControl]="bottleProdIdCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="add($event)">
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" >
      @for (prod of filteredBottleProducts | async; track prod) {
        <mat-option [value]="prod.id">
          {{ prod.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <lib-button fxFlex="1 0 auto" (buttonClick)="saveRule()" tooltip="Save rule">{{ saveStatus === 1 ? 'Saving...' :  saveStatus === 2 ? 'Saved' : 'Save rule' }}</lib-button>
  <lib-button fxFlex="1 0 auto" (buttonClick)="removeRule()" tooltip="Remove rule">Remove</lib-button>
</div>
<lib-loading-overlay [isLoading]="!isSetFormValueDone" [message]="'loading...'" />
